import axiosInstance from './service'

export const uploadFiles = async (formData) => {
  const res = await axiosInstance.post('/file-upload', formData)
  return res
}
